module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic.cdf8e1cd.woff2";